import { useCallback, useState } from 'react';

export const CreateList = ({
  className = '',
  items,
  cb = (p?: string) => {},
}: {
  className?: string;
  items: (
    | 'STRATEGIES'
    | 'SOURCE'
    | 'INSPIRATION'
    | { title: string; groupBy: 'STRATEGIES' | 'SOURCE' | 'INSPIRATION' }
  )[];
  cb: any;
}) => {
  const [selected, setSelected] = useState(
    typeof items[0] === 'object' ? items[0].title : items[0]
  );

  const handleClick = useCallback(
    (
      item:
        | string
        | { title: string; groupBy: 'STRATEGIES' | 'SOURCE' | 'INSPIRATION' }
    ) => {
      setSelected(typeof item === 'object' ? item.title : item);
      cb(typeof item === 'object' ? item.groupBy : item);
    },
    []
  );

  return (
    <div className={`${className} flex items-center`}>
      {items.map((item, i) => {
        const title = typeof item === 'object' ? item.title : item;
        const isSelected = selected === title;

        return (
          <span
            key={title}
            className={`
              flex
              flex-1
              h-full
              ${i && 'border-l border-grey-10 dark:border-grey-70'}
            `}
          >
            <span
              className={`
                flex
                flex-col
                flex-1
                items-center
                h-12
                cursor-pointer
                ${
                  isSelected
                    ? 'border-b-3 border-lime'
                    : 'border-b border-grey-10 dark:border-grey-70  '
                }
              `}
              onClick={() => handleClick(item)}
            >
              <span
                className={`
                  flex
                  m-auto
                  font-medium
                  ${
                    isSelected ? 'text-black dark:text-grey-30' : 'text-grey-50'
                  }
                `}
              >
                {title}
              </span>
            </span>
          </span>
        );
      })}
    </div>
  );
};
